import DataForm from "./DataForm.js";
import DataFormItem from "./DataFormItem.js";
import { useFormInstance } from "./DataFormHook.js";
DataForm.Item = DataFormItem;
DataForm.useFormInstance = useFormInstance;
export default DataForm;
